/* @flow */
import * as React from 'react';
import { Flex } from '@locus-taxy/neo-ui';

class SectionWrap extends React.PureComponent {
    render() {
        return (
            <Flex flexDirection="column" width="100%" height="fluid">
                {this.props.children}
            </Flex>
        );
    }
}

export { SectionWrap };
export default SectionWrap;
